function resourceCategoryModel() {
  this.$get = function $get_resourceCategoryModel(ResourceCategoryBuilder) {
    return {
      model: [],

      update: function update_resourceCategoryModel(data) {
        this.model = [];

        _.forEach(data.resource_category, (category) => {
          category = new ResourceCategoryBuilder(category);
          this.model.push(category);
        });

        this.model = _.sortBy(this.model, 'name');
        return this;
      },

      getCategoryById: function getCategoryById(categoryId) {
        return _.filter(this.model, (res) => res.id === parseInt(categoryId, 10));
      }
    };
  };
}

angular.module('capability-ng-resources').provider('resourceCategoryModel', resourceCategoryModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/models/resource_category_model.es.js